import { isArray } from 'angular';
import { Log } from '../../log';
const log = Log.channel('TooltipExtension');
export default class TooltipExtension {
    constructor($scope, $ionicPopover) {
        this.$scope = $scope;
        this.$ionicPopover = $ionicPopover;
        this.hideTooltip = () => {
            if (this.$scope.tooltip) {
                this.$scope.tooltip.remove();
                this.$scope.tooltip = null;
            }
        };
        this.showTooltip = (message, $event, options) => {
            this.hideTooltip();
            this.$scope.tooltipMessage = message;
            this.$scope.tooltipOptions = options;
            this.$scope.onClick = this.hideTooltip;
            this.$scope.isArray = msg => {
                return isArray(msg);
            };
            return this.$ionicPopover
                .fromTemplateUrl('tooltip.html', {
                scope: this.$scope,
            })
                .then(popover => {
                this.$scope.tooltip = popover;
                this.$scope.tooltip.show($event);
                return popover;
            });
        };
        this.tooltip = {
            hide: this.hideTooltip,
            show: this.showTooltip,
        };
        log.info('initializing');
        this.$scope.$on('$destroy', () => {
            this.tooltip.hide();
        });
    }
}
